// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#footer[data-v-e4b030e6] .v-btn:not(.v-btn--active){border-top:#bdbdbd;color:#bdbdbd!important}#footer[data-v-e4b030e6] .v-btn--active{border-top:2px solid}#footer[data-v-e4b030e6] .v-btn--active:before{background-color:transparent}.v-item-group.v-bottom-navigation[data-v-e4b030e6]{border-top:1px solid #efefef;box-shadow:none!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
